// extracted by mini-css-extract-plugin
export default {"innerWrapper":"gw-z","tooltipWrapper":"hw-z","icon":"iw-z","tooltip":"jw-z","content":"kw-z"};